var map = {
	"./dkjl.png": "bc61",
	"./hdbm.png": "dbda",
	"./jjqd-back.png": "cb84",
	"./qddk-back.png": "1851",
	"./qdjl.png": "c34c",
	"./tyjl-back.png": "0e24",
	"./xxsj.png": "798e",
	"./zyjl.png": "6247"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a4c7";